import { render, staticRenderFns } from "./oem.vue?vue&type=template&id=06d1db0e&scoped=true&"
import script from "./oem.vue?vue&type=script&lang=js&"
export * from "./oem.vue?vue&type=script&lang=js&"
import style0 from "./oem.vue?vue&type=style&index=0&id=06d1db0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d1db0e",
  null
  
)

export default component.exports